import {connect} from "react-redux";
import SecurePage from "./SecurePage";
import * as authActions from "../actions/AuthActions";
import {getViewContext, getViewTitle} from "../reducers/viewReducer";

function mapStateToProps(state) {
  const context = getViewContext(state.get("view"));
  return {
    viewContext: context,
    viewTitle: getViewTitle(state.get("view")),
    selection: getSelection(state.get("selection"), context)
  }
}

export default connect(mapStateToProps, {...authActions})(SecurePage);